import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';

const handler = ({ httpClient }, { venueId, serviceIds }) => {
  const endpoint = URLS.manageServices.scheduleIncrements.list(venueId, serviceIds);

  return httpClient
    .get(endpoint)
    .then(transformV2ClientResponse)
    .then(data => data.serviceScheduleIncrements);
};

export default makeEntityScaffold('SAGA.API.SCHEDULE_INCREMENTS', handler, { defaultKey: (_, { venueId }) => venueId });
